import api from './api';

const approverMasterService = {
  getAllApprovers: async (params = {}) => {
    try {
      const response = await api.get('/approver-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all approver master records:', error);
      throw error;
    }
  },

  getApproverById: async (id) => {
    try {
      const response = await api.get(`/approver-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching approver master record with ID ${id}:`, error);
      throw error;
    }
  },

  getNextApproverCode: async () => {
    try {
      const response = await api.get('/approver-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next approver code:', error);
      throw error;
    }
  },

  createApprover: async (approverData) => {
    try {
      const response = await api.post('/approver-master', approverData);
      return response.data;
    } catch (error) {
      console.error('Error creating approver master record:', error);
      throw error;
    }
  },

  updateApprover: async (id, approverData) => {
    try {
      const response = await api.put(`/approver-master/${id}`, approverData);
      return response.data;
    } catch (error) {
      console.error(`Error updating approver master record with ID ${id}:`, error);
      throw error;
    }
  },

  deleteApprover: async (id) => {
    try {
      const response = await api.delete(`/approver-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting approver master record with ID ${id}:`, error);
      throw error;
    }
  },

  getApproverStats: async () => {
    try {
      const response = await api.get('/approver-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching approver master stats:', error);
      throw error;
    }
  },

  getActiveApprovers: async () => {
    try {
      const response = await api.get('/approver-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active approvers:', error);
      throw error;
    }
  },
};

export default approverMasterService;

